import { useEffect } from 'react';
import { useTranslation } from 'next-i18next/pages';
import { Headline } from '@ev-tech/ui-core-components/Headline';
import { Copy } from '@ev-tech/ui-core-components/Copy';
import { Button } from '@ev-tech/ui-core-components/Button';
import { type ErrorBoundaryFallback, addNextjsError } from '@datadog/browser-rum-nextjs';

import { ShopBanner } from '@/icons/ShopBanner';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useSettings } from '@/hooks/useSettings';

import styles from './ErrorPage.module.css';

export const ErrorPage: ErrorBoundaryFallback = ({ error, resetError }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.common);
  const { countryCode, language } = useSettings();

  useEffect(() => {
    error.message = `Critical: Unhandled client side error\n${error.message}`;
    addNextjsError(error);
  }, [error]);

  return (
    <div className={styles.page}>
      <div className={styles.card} role="alert" aria-live="assertive">
        <ShopBanner />
        <div className={styles.text}>
          <Headline as="h1" size="h4" label={t('search.error.headline')} />
          <Copy size="l" text={t('search.error.text')} />
        </div>
        <div className={styles.actions}>
          <Button
            as="a"
            href={`/${countryCode.toLowerCase()}/${language}`}
            label={t('search.error.goToHomepage')}
            size="medium"
            variant="tertiary"
          />
          <Button as="button" label={t('search.error.back')} onClick={resetError} size="medium" variant="primary" />
        </div>
      </div>
    </div>
  );
};
